


















import Vue from 'vue'
import SectionTitle from '@/components/SectionTitle.vue'
const CustomizeSteps = Vue.extend({
  components: {
    SectionTitle
  },
  computed: {
    steps () {
      return [
        {
          logo: require('@/assets/image/service/1.png'),
          title: this.$t('service.customizeT1'),
          details: this.$t('service.customizeD1')
        },
        {
          logo: require('@/assets/image/service/2.png'),
          title: this.$t('service.customizeT2'),
          details: this.$t('service.customizeD1')
        },
        {
          logo: require('@/assets/image/service/3.png'),
          title: this.$t('service.customizeT3'),
          details: this.$t('service.customizeD1')
        },
        {
          logo: require('@/assets/image/service/4.png'),
          title: this.$t('service.customizeT4'),
          details: this.$t('service.customizeD1')
        },
        {
          logo: require('@/assets/image/service/5.png'),
          title: this.$t('service.customizeT5'),
          details: this.$t('service.customizeD1')
        }
      ]
    }
  }
})
export default CustomizeSteps
